import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import Icon from '../components/ui/Icon.jsx';
import { useToast } from '../context/ToastContext.jsx';
import { resetPassword as resetPasswordApi } from '../api/userApi.js';

// 密碼重設信連結的落地頁：/reset-password?token=xxx
// 輸入新密碼 → 送 token + 新密碼到後端完成重設。
const cardStyle = { background: '#fff', borderRadius: 16, boxShadow: 'var(--shadow-sm)', padding: '40px 28px' };
const h1Style = { font: '900 24px "Noto Sans TC", sans-serif', color: 'var(--navy)', margin: 0 };
const labelStyle = { font: '700 13px "Noto Sans TC", sans-serif', color: 'var(--navy)' };
const inputStyle = {
  width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: 10,
  border: '1.5px solid var(--line)', font: '500 15px "Noto Sans TC", sans-serif', marginTop: 6,
};
const btnStyle = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, width: '100%',
  padding: '13px 22px', borderRadius: 999, background: 'var(--navy)', color: '#fff', border: 'none',
  font: '800 15px "Noto Sans TC", sans-serif', cursor: 'pointer', marginTop: 20, textDecoration: 'none',
};

function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (submitting) return;
    if (!pw || pw.length < 8) { showToast('密碼至少 8 個字元', 'error'); return; }
    if (pw !== pw2) { showToast('兩次輸入的密碼不一致', 'error'); return; }
    setSubmitting(true);
    try {
      await resetPasswordApi(token, pw);
      setDone(true);
    } catch (err) {
      showToast(err.message || '重設失敗，連結可能已失效，請重新申請', 'error', 4000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main style={{ maxWidth: 520, margin: '0 auto', padding: '64px 20px 80px', textAlign: 'center' }}>
      <div style={cardStyle}>
        {!token ? (
          <>
            <h1 style={h1Style}>連結無效</h1>
            <p style={{ color: 'var(--ink-soft)', marginTop: 12, lineHeight: 1.7 }}>
              缺少重設 token。請從信件中的連結進入，或回登入頁重新申請忘記密碼。
            </p>
            <Link to="/login" style={btnStyle}>回登入 <Icon name="arrow" size={14} /></Link>
          </>
        ) : done ? (
          <>
            <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--mint)', color: 'var(--mint-deep)', display: 'grid', placeItems: 'center', margin: '0 auto 20px' }}>
              <Icon name="check" size={36} />
            </div>
            <h1 style={h1Style}>密碼已重設</h1>
            <p style={{ color: 'var(--ink-soft)', marginTop: 12, lineHeight: 1.7 }}>你的密碼已更新，請用新密碼登入。</p>
            <button onClick={() => navigate('/login')} style={btnStyle}>前往登入 <Icon name="arrow" size={14} /></button>
          </>
        ) : (
          <>
            <h1 style={h1Style}>設定新密碼</h1>
            <p style={{ color: 'var(--ink-soft)', marginTop: 12 }}>請輸入新密碼（至少 8 個字元）。</p>
            <div style={{ textAlign: 'left', marginTop: 18 }}>
              <label style={labelStyle}>新密碼</label>
              <input type={showPw ? 'text' : 'password'} value={pw} onChange={e => setPw(e.target.value)}
                placeholder="至少 8 個字元" style={inputStyle} />
            </div>
            <div style={{ textAlign: 'left', marginTop: 14 }}>
              <label style={labelStyle}>再次確認</label>
              <input type={showPw ? 'text' : 'password'} value={pw2} onChange={e => setPw2(e.target.value)}
                placeholder="再輸入一次" style={inputStyle}
                onKeyDown={e => { if (e.key === 'Enter') submit(); }} />
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 12, font: '500 13px "Noto Sans TC", sans-serif', color: 'var(--ink-soft)', cursor: 'pointer' }}>
              <input type="checkbox" checked={showPw} onChange={e => setShowPw(e.target.checked)} /> 顯示密碼
            </label>
            <button onClick={submit} disabled={submitting} style={{ ...btnStyle, opacity: submitting ? 0.7 : 1 }}>
              {submitting ? '處理中…' : <>重設密碼 <Icon name="arrow" size={14} /></>}
            </button>
          </>
        )}
      </div>
    </main>
  );
}

export default ResetPasswordPage;
